module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/4_96b83004c567ee7ac9af9367a56c47c6.png";